module.exports = __webpack_public_path__ + "static/media/raven_funny_02.2f69986c.svg";